webpackJsonp([212840214148382],{

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactJss = __webpack_require__(6);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dots = __webpack_require__(22);
	
	var _dots2 = _interopRequireDefault(_dots);
	
	var _components = __webpack_require__(17);
	
	var _containers = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      minHeight: '100vh',
	      flexDirection: 'column'
	    },
	
	    // MAIN
	    main: {
	      flex: '1',
	      '& h1': {
	        marginTop: 0
	      }
	    },
	    mainContainer: {
	      padding: 20
	    },
	    leftContent: {
	      maxWidth: '100%'
	    },
	
	    // TEAM
	    team: {
	      marginTop: 60,
	      padding: [0, 20]
	    },
	
	    // FOOTER
	    footer: {
	      backgroundColor: theme.palette.inverted.base,
	      backgroundImage: 'url(' + _dots2.default + ')',
	      position: 'relative',
	      marginTop: 120
	    },
	    footerDrops: {
	      display: 'none'
	    },
	
	    // small +
	    '@media screen and (min-width: 48em)': {
	      // MAIN
	      mainContainer: {
	        paddingTop: 120
	      },
	      leftContent: {
	        maxWidth: 550
	      },
	
	      // TEAM
	      team: {
	        marginTop: 20
	      },
	
	      // FOOTER
	      footerDrops: {
	        display: 'block'
	      }
	    }
	  };
	};
	
	var ConsultingPage = function ConsultingPage(_ref) {
	  var classes = _ref.classes;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Consulting | Real World React'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: classes.root },
	      _react2.default.createElement(_components.Header, null),
	      _react2.default.createElement(
	        'div',
	        { className: classes.main },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(classes.mainContainer, 'container') },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-8' },
	              _react2.default.createElement(
	                'div',
	                { className: classes.leftContent },
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  'In person, on-site consulting services for',
	                  ' ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'text-inverted background-secondary' },
	                    'scaling your architecture'
	                  ),
	                  ' ',
	                  'effectively'
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: 'col-sm-4' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-8' },
	              _react2.default.createElement(
	                'div',
	                { className: classes.leftContent },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Your engineering team is full of talented and capable individuals. They are led by competent managers. But even the best teams can benefit from outside, expert advice.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Our consulting services can help you to effectively scale your architecture and to ensure that the decisions you are making today will benefit you in 10 years time, not get you into technical debt.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Contact us today to learn how one of our expert consultants can help you to build tomorrow\u2019s architecture, today.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-4' },
	              _react2.default.createElement(_components.Quote, null)
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(classes.team, 'container') },
	        _react2.default.createElement(_containers.Team, null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: classes.footer },
	        _react2.default.createElement(
	          'div',
	          { className: classes.footerDrops },
	          _react2.default.createElement(_components.Drops, { bottom: true })
	        ),
	        _react2.default.createElement(_components.Footer, { footerContent: _react2.default.createElement(_containers.SignUp, null), headerContent: _react2.default.createElement(_containers.Contact, null) })
	      )
	    )
	  );
	};
	
	exports.default = (0, _reactJss2.default)(styles)(ConsultingPage);
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-consulting-js-4293f7b7bc31d736e0fd.js